import { Box, makeStyles } from '@material-ui/core'
import React from 'react';

let useStyles = makeStyles((theme) => ({
    root: {
        margin: "60px 9px 60px 9px",
        ...theme.grid.gridMdContent,
        width: 900,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        [theme.breakpoints.down('800')]: {
            width: 440,
            maxWidth:'90%',
            margin: 'auto',

        }
    },
    images: {
        filter: 'grayscale(100%)',
        margin: 5,
        height: 70,
        width: 79,
        cursor: "pointer",
        '&:hover':{
            filter: 'grayscale(0%)',
        }
    }
}))


export default function Index() {

    let classes = useStyles();

    return (
        <Box className={classes['root']}>
            {
                data.map((item, ind) => (
                    <a href={item.link} target="_blank" key={ind}>
                        {/* <svg
                            style={{ margin: 5, height: 70, width: 79, cursor: "pointer" }}
                            className="hoverScale transition-custom"
                        >
                            <use xlinkHref={`/sprit.svg#customer${item.name}`} ></use>
                        </svg> */}
                        <img
                            className={classes['images']}
                            src={`/assets/images/icons/${ind + 1}.png`}
                        />
                        <p
                            style={{ margin: 5, height: 70, width: 79, cursor: "pointer", fontSize: 12 }}
                        >{item.title}</p>
                    </a>
                ))
            }
        </Box>
    )
}



const data =
    [
        // { name: 1, link: "https://www.seo.ir/", title: 'سازمان بورس و اوراق بهادار' },
        // { name: 2, link: "http://www.tsetmc.com", title: 'بورس و اوراق بهادار تهران' },
        // { name: 4, link: "https://www.ifb.ir/", title: 'فرابورس' },
        // { name: 7, link: "https://www.ime.co.ir/", title: 'بورس کالای ایران' },
        // { name: 9, link: "https://www.irenex.ir/", title: 'بورس انرژی' },
        // { name: 6, link: "https://www.seba.ir/", title: 'کانون کارگزاران بورس' },
        // // { name: 3, link: "", title:''  },
        // { name: 5, link: "http://tsetmc.ir/Site.aspx", title: 'شرکت مدیریت فناوری بورس تهران' },
        // { name: 8, link: "https://www.csdiran.ir", title: 'شرکت سپرده گذاری مرکزی' },
        { name: 1, link: "https://www.seo.ir/", title: 'سازمان بورس' },
        { name: 2, link: "http://www.tsetmc.com", title: 'بورس اوراق بهادار تهران' },
        { name: 4, link: "https://www.ifb.ir/", title: 'فرابورس' },
        { name: 7, link: "https://www.ime.co.ir/", title: 'بورس کالای' },
        { name: 9, link: "https://www.irenex.ir/", title: 'بورس انرژی' },
        { name: 6, link: "https://www.seba.ir/", title: 'کانون کارگزاران' },
        // { name: 3, link: "", title:''  },
        { name: 5, link: "http://tsetmc.ir/Site.aspx", title: 'مدیریت فناوری بورس تهران' },
        { name: 8, link: "https://www.csdiran.ir", title: 'سپرده گذاری مرکزی' },
    ]
